module.exports = __webpack_public_path__ + "img/Nest Bank .8c442926.png";